<template>
	<div class="contain">
		<img class="imgs" src="../../../assets/c17/guide01.png" alt="솔닥 약국 방문 수령 방법 안내 (아래내용 참고)" />
		<img class="imgs" src="../../../assets/c17/guide02.png" alt="솔닥 약국 방문 수령 방법 안내 (아래내용 참고)" />
		<img class="imgs" src="../../../assets/c17/guide03.png" alt="솔닥 약국 방문 수령 방법 안내 (아래내용 참고)" />
		<div class="sr-only">
			<div>
				<h2>솔닥 약국 방문 수령 방법 안내</h2>
				<p><strong>쉽고 간단한 조제약 약국 방문 수령 방법</strong> 지금 바로 알려드려요!</p>
				<div>
					<div>
						<strong>처방전달시스템(PPDS) 연동</strong>
						<p>솔닥은 대한약사회의 처방전달시스템(PPDS)과 연동하여 안전하고 편리한 조제 요청이 가능합니다.</p>
					</div>
					<p>PPDS 시스템을 통한 조제가 어려운 경우, 약국에 팩스로 처방전을 보내드리고 있습니다. (고객센터 : 02-6954-7676)</p> 
					<ol>
						<li>
							<strong><span>step 01</span>약 수령할 약국 선택하기</strong>
							<p>지도 상에서 방문할 약국을 직접 선택하고 [이 약국으로 처방전 보내기] 버튼을 클릭하세요</p>
						</li>
						<li>
							<strong><span>step 02</span>수령 시간 선택 후 처방전 보내기</strong>
							<p>약국 방문 시간을 선택하고 [이 약국으로 처방전 보내기] 버튼을 클릭하세요</p>
							<span>약국 변경이 필요할 때 [ 내역 확인하기 ] 클릭 후 화면에서 처방전을 회수하고 약국을 다시 선택할 수 있어요</span>
						</li>
						<li>
							<strong><span>step 03</span>약국에 조제 요청하기</strong>
							<p>약국에서 처방전을 확인하면 카카오 알림톡이 도착해요 알림톡 내 [ 조제 요청하기 ] 버튼을 클릭하세요</p>
						</li>
						<li>
							<strong><span>step 04</span>조제 요청 완료하기</strong>
							<p>해당 화면 [ 조제 요청하기 ] 버튼으로 조제 요청이 완료되며 조제 과정을 확인할 수 있어요</p>
							<span>조제 요청 완료 이후에는 약국 변경이 불가능해요.</span>
						</li>
						<li>
							<strong><span>step 05</span>약국에서 약 수령하기</strong>
							<p>약국 조제 완료 카카오 알림톡이 도착하면 약국에서 약을 수령 할 수 있어요</p>
						</li>
					</ol>
				</div>
			</div>
		</div>
		<div class="faq-area">
			<div class="faq-title">
				<span>FAQ</span>
				<h3>자주 묻는 질문</h3>
			</div>
			<div class="faq-content">
                <nav class="tabmenu">
                    <ul class="tab-list">
                        <li :class="{ 'on': activeTab === 0 }">
                            <a href="#" @click="changeTab(0)"><span>약 조제 및 수령 관련</span></a>
                        </li>
                        <li :class="{ 'on': activeTab === 1 }">
                            <a href="#" @click="changeTab(1)"><span>처방전 관련 및 기타 문제</span></a>
                        </li>
                    </ul>
                </nav>
				<div class="tab-content" :style="{ display: activeTab === 0 ? 'block' : 'none' }">
                    <h4 class="sr-only">약 조제 및 수령 관련</h4>
                    <div name="faq" class="faq" :id="'accordion-tab1'">
                        <div class="faq-inner">
                            <div class="faq-item" v-for="(faq, index) in faqDataTab1" :key="index">
                                <button type="button" class="faq-btn-title" @click="openTab1(index)">
                                    <strong>
                                        <span class="q">Q</span>{{ faq.title }}
                                    </strong>
                                    <img
                                        v-if="selectedTab1 !== index"
                                        src="../../../assets/c17/chevron-bottom.png"
                                        alt="펼치기"
                                        class="ico-arrow"
                                    />
                                    <img
                                        v-else
                                        src="../../../assets/c17/chevron-top.png"
                                        alt="닫기"
                                        class="ico-arrow"
                                    />
                                </button>
                                <transition
                                    name="accordion"
                                    @enter="start"
                                    @after-enter="end"
                                    @before-leave="start"
                                    @after-leave="end"
                                >
                                    <div class="faq-con" v-show="selectedTab1 === index">
                                        <div class="inner">
                                            <div>
                                                <span class="a">A</span>
                                                <div>
                                                    <p v-html="faq.content"></p>
													<ul>
														<li class="detail">{{ faq.detail }}</li>
													</ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                </div>
				<div class="tab-content" :style="{ display: activeTab === 1 ? 'block' : 'none' }">
					<h4 class="sr-only">처방전 관련 및 기타 문제</h4>
					<div name="faq" class="faq" :id="'accordion-tab2'">
						<div class="faq-inner">
							<div class="faq-item" v-for="(faq, index) in faqDataTab2" :key="index">
								<button type="button" class="faq-btn-title" @click="openTab2(index)">
									<strong>
										<span class="q">Q</span>{{ faq.title }}
									</strong>
									<img
										v-if="selectedTab2 !== index"
										src="../../../assets/c17/chevron-bottom.png"
										alt="펼치기"
										class="ico-arrow"
									/>
									<img
										v-else
										src="../../../assets/c17/chevron-top.png"
										alt="닫기"
										class="ico-arrow"
									/>
								</button>
								<transition
									name="accordion"
									@enter="start"
									@after-enter="end"
									@before-leave="start"
									@after-leave="end"
								>
									<div class="faq-con" v-show="selectedTab2 === index">
										<div class="inner">
											<div>
												<span class="a">A</span>
												<div>
													<p v-html="faq.content"></p>
													<ul>
														<li class="detail">{{ faq.detail }}</li>
														<li class="detail" v-if="faq.detail2">{{ faq.detail2 }}</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</transition>
							</div>
						</div>
					</div>
				</div>
            </div>
		</div>
		<div class="cautions-area">
			<div class="cautions-area-inner">
				<h3 class="cautions-title">주의 사항 및 추가 안내</h3>
				<ul class="cautions-list">
					<li>비대면진료를 통한 처방의 경우, 마약류 및 오·남용 우려 의약품, 사후피임약은 처방이 불가능합니다.</li>
					<li>1회 처방 시 최대 90일 한도 내에서 처방이 가능합니다.</li>
					<li>환자에게 전달된 처방전은 보관용이며, 조제 가능한 처방전은 대한약사회 처방전달시스템(PPDS)를 통해 약국으로 전달됩니다.
						<ul>
							<li>보건복지부 지침 상, 조제 가능한 처방전은 약국으로 전달만 가능합니다. <span class="text-gray">(단, 약국에 전달된 처방전을 환자가 직접 방문해서 받아 오는 건 가능합니다.)</span></li>
						</ul>
					</li>
					<li>약사는 환자와 협의하여 조제 가능 여부, 의약품 수령 방식을 결정합니다. 재택 수령 방식은 특정 조건을 충족하는 경우에 한해 가능합니다. (재택 수령 가능 조건 대상자 : 섬벽지 거주자, 장애인, 감염병 확진자, 희귀질환자 등 )</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "c17",
	data() {
        return {
			activeTab: 0,
			selectedTab1: 0,
			selectedTab2: 0,
			faqDataTab1: [ 
				{
                    title: "약은 어떻게 조제하고 어떻게 수령하나요?",
                    content: "솔닥 앱을 통해 대한약사회 처방전달시스템(PPDS)으로<br>조제를 요청할 수 있습니다. 조제된 약은 선택하신 약국에서<br>직접 수령하셔야 합니다.",
					detail: "대리수령과 약 배송(재택수령)도 가능하지만 특정 조건일 경우에 한합니다. 자세한 정보는 아래 FAQ를 확인해주세요.",
                },
                {
                    title: "대리수령은 어떻게 가능한가요?",
                    content: "대리수령은 환자와 약사의 협의 하에 가능합니다. 대리인의 정보(성명, 연락처, 환자와의 관계)를 약사가 요청할 수 있습니다.",
					detail: "대상자 : 환자의 가족, 배우자, 형제, 자매, 노인의료복지/장애인 시설 근무자, 그 외 환자의 진료를 위해 필요한 인원(교정시설 직원, 무연고자의 보호자, 주 보호자 등)",
                },
                {
                    title: "약 배송(재택 수령)은 가능한가요?",
                    content: "대부분의 경우 약 배송은 불가합니다. 직접 약국을 방문해야 합니다. ",
					detail: "배송 가능 대상자 : 섬벽지 거주자, 취약계층(65세 이상 노인, 장애인, 감염병 확진자, 희귀질환자 등)",
                },
                {
                    title: "약국에서 약이 없어 조제할 수 없다고 합니다.",
                    content: "조제가 어려운 경우 병원에 동일 성분의 다른 약으로 처방 변경을 요청할 수 있습니다.",
					detail: "처방전 회수 후, 솔닥 고객센터에 연락해주시면 병원에 처방 변경 요청을 도와드립니다. (고객센터 : 02-6954-7676)",
                },
			],
			faqDataTab2: [
				{
                    title: "저한테 전달된 처방전으로 조제할 수 없나요?",
                    content: "보건복지부 지침에 따라, 환자에게 전달된 처방전은 참고용입니다. 조제 가능한 처방전은 약국으로만 직접 전송됩니다.",
					detail: "약국으로 전송된 처방전을 수령하는 것은 가능합니다.",
                },
                {
                    title: "약국에서 처방전을 받지 못했다고 합니다.",
                    content: "솔닥 앱을 통해 처방전을 보내면, 대한약사회 처방전달시스템(PPDS)를 통해 전달됩니다. 약사에게 처방전달시스템을 확인하도록 안내해주세요.",
					detail: "팩스로 처방전을 보내야 하는 경우 솔닥 고객센터에 진료 정보(성함/연락처/진료일시)와 약국정보(이름/위치/팩스번호)를 제공해주시면 약국에 팩스를 전송해드립니다.",
                },
                {
                    title: "근처 약국이 보이지 않거나 처방전을 보낼 수 없어요.",
                    content: "대한약사회 처방전달시스템(PPDS)에 가입된 약국만 솔닥 앱으로 확인하실 수 있습니다. 약국이 처방전달시스템을 활성화하지 않았거나, 약국 운영 시간이 아닐 수 있습니다.",
					detail: "해결 방법 : 약국에 PPDS 활성화를 요청하거나 다른 지역의 약국을 재검색 또는 약국 운영 시간대에 재검색",
                },
                {
                    title: "오늘 내로 조제해야 하나요? 처방전 유효기간이 궁금해요.",
                    content: "처방전 유효기간은 솔닥 앱에서 확인하실 수 있습니다. 유효기간 내에 조제하지 않으면 처방전은 폐기됩니다. ",
					detail: "유효기간 내에 조제를 완료해주세요. 일요일과 공휴일은 유효기간에서 제외됩니다.",
					detail2: "처방전 확인 방법 : [솔닥 앱 > 예약/내역 > 진료내역보기 > 해당 예약의 처방전 > 처방전 하단 확인]",
                },
			],
        };
    },
	methods: {
        changeTab(tabIndex) {
            this.activeTab = tabIndex;
        },
        openTab1(index) {
            this.selectedTab1 = this.selectedTab1 === index ? null : index;
        },
        openTab2(index) {
            this.selectedTab2 = this.selectedTab2 === index ? null : index;
        },
        start(el) {
            el.style.height = el.scrollHeight + "px";
        },
        end(el) {
            el.style.height = "";
        },
    }
};
</script>

<style scoped>
.contain {
	width: 100%;
	position: relative;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-direction: column;
	min-width: 800px;
}
.last-img {
	padding-bottom: 150px;
}
.contain .sr-only {
	position: absolute;
	left: -9999px;
	width: 1px;
	height: 1px;
	margin: 0 !important;
	font-size: 0;
	line-height: 0;
	overflow: hidden;
}

.faq-area {
	width: 100%;
	max-width: 800px;
	padding: 38px 40px 65px;
}
.faq-title {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	gap: 53px;
}
.faq-title span {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 135px;
	height: 48px;
	border-radius: 4px;
	background: #EBF1FF;

	font-size: 28px;
	font-weight: 600;
	color: #2071FF;
}
.faq-title h3 {
	margin: 0;
	font-weight: 600;
	line-height: 55px;
	font-size: 55px;
	color: #000000;
}

.faq-content {
	margin-top: 100px;
}
nav.tabmenu .tab-list {
	display: flex;
	gap: 2px;
	list-style: none;
    padding: 0;
    margin: 0;
	border-bottom: 2px solid #2071FF;
}
.tab-list li {
	width: 50%;
	height: 75px;
}
.tab-list li a {
	display: inline-block;
	width: 100%;
	height: 100%;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
	background: #F2F2F2;
	font-size: 26px;
	font-weight: 400;
	text-align: center;
	line-height: 75px;
	color: #000000;
}
.tab-list li.on a {
	background: #2071FF;
	font-weight: 600;
	color: #FFFFFF;
}
.tab-list li a:hover {
	text-decoration: none;
}

.faq {
    position: relative;
    width: 100%;
	max-width: 800px;
}
.faq-inner {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
}
.faq-inner .faq-item {
    position: relative;
    width: 100%;
    border-bottom: 1px solid #CCCCCC;
}
.faq-inner .faq-btn-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 92px;
	border: none;
    background: #FFFFFF;
    padding: 0 20px 0 22px;
}
.faq-inner .faq-btn-title strong {
	display: flex;
	align-items: flex-start;
	gap: 24px;
    font-size: 26px;
    font-weight: 400;
	color: #1A1A1A;
	text-align: left;
}
.faq-inner .q {
    font-size: 26px;
    font-weight: 700;
	color: #2071FF;
}
.faq-inner .faq-con {
    width: 100%;
    overflow: hidden;
}
.faq-con .inner {
	width: 100%;
	padding: 24px 18px 27px 22px;
	border-top: 1px solid #CCCCCC;
}
.faq-con .inner > div {
	display: flex;
	align-items: flex-start;
	gap: 24px;
    font-size: 26px;
    font-weight: 400;
    line-height: 42px;
	color: #666666;
}
.faq-con .inner > div ul {
	margin: 0;
	padding: 0;
}
.faq-con .inner > div .detail {
	position: relative;
	display: block;
	padding-left: 39px;
}
.faq-con .inner > div .detail::before {
	content: '';
	position: absolute;
	top: 17px;
	left: 16px;
	width: 6px;
	height: 6px;
	background: #666666;
	border-radius: 50%;
}
.faq-con .inner .a {
	position: relative;
    font-size: 26px;
    font-weight: 700;
	color: #000000;
}
.faq-con .inner .a::before {
	content: '';
	position: absolute;
	left: 0;
	bottom: 4px;
	width: 19px;
	height: 3px;
	background: #000000;
}
.faq-con .inner p {
	margin: 0;
}

.accordion-enter-active,
.accordion-leave-active {
    will-change: height, opacity;
    transition: height 0.8s ease, opacity 0.8s ease;
    overflow: hidden;
}
.accordion-enter,
.accordion-leave-to {
    height: 0 !important;
    opacity: 0;
}

.cautions-area {
	width: 100%;
	max-width: 800px;
	padding: 0 40px 240px;
}
.cautions-area-inner {
	padding: 40px 44px 44px;
	border-radius: 4px;
	background: #F6F6F6;
}
.cautions-title {
	position: relative;
	margin-bottom: 28px;
	padding-left: 43px;
	font-size: 26px;
	font-weight: 600;
	line-height: 31px;
	color: #1A1A1A;
}
.cautions-title::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	width: 30px;
	height: 31px;
	background: url('../../../assets/c17/ico-cautions.png');
	background-size: 30px 31px;
}
.cautions-list {
	margin: 0;
	padding: 0;
}
.cautions-list * {
	list-style: none;
	padding: 0;
}
.cautions-list li {
	padding-left: 26px;
	position: relative;
	font-size: 23px;
	font-weight: 400;
	line-height: 38px;
	color: #000000;
}
.cautions-list li + li {
	margin-top: 10px;
}
.cautions-list li::before {
	content: '';
	position: absolute;
	top: 16px;
	left: 10px;
	width: 4px;
	height: 4px;
	background: #000000;
	border-radius: 50%;
}
.text-gray {
	color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/pc_view/contents/c17.vue